var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import { isRocheBuffersComponent } from "../../KitDeserializer";
import ErrorDisplay from "../../ErrorDisplay";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { priceColumn, PriceDisplay } from "../rna-fish/EditKitForm";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import { LiquidVolume, MicroliterVolume } from "./RnaCatalog";
var BufferForm = /** @class */ (function (_super) {
    __extends(BufferForm, _super);
    function BufferForm(props) {
        var _this = _super.call(this, props) || this;
        _this.amplificationScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proBufferScales
                .concat(_this.props.bufferState.amplificationBufferScale), function (s) { return s; });
        };
        _this.blockingSolutionScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proBufferScales
                .concat(_this.props.bufferState.blockingSolutionScale), function (s) { return s; }).map(function (v) {
                return {
                    text: v,
                    value: v
                };
            });
        };
        _this.endogenousEnzymeScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proBufferScales
                .concat(_this.props.bufferState.endogenousEnzymeScale), function (s) { return s; }).map(function (v) {
                return {
                    text: v,
                    value: v
                };
            });
        };
        _this.preHybridizationScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proBufferScales
                .concat(_this.props.bufferState.preHybridizationScale), function (s) { return s; }).map(function (v) {
                return {
                    text: v,
                    value: v
                };
            });
        };
        _this.hrpQuencherScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proBufferScales
                .concat(_this.props.bufferState.hrpQuencherScale), function (s) { return s; }).map(function (v) {
                return {
                    text: v,
                    value: v
                };
            });
        };
        _this.bluingAgentScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proBufferScales
                .concat(_this.props.bufferState.bluingAgentScale), function (s) { return s; }).map(function (v) {
                return {
                    text: v,
                    value: v
                };
            });
        };
        _this.antigenRetrievalScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proBufferScales
                .concat(_this.props.bufferState.antigenRetrievalScale), function (s) { return s; }).map(function (v) {
                return {
                    text: v,
                    value: v
                };
            });
        };
        _this.dewaxScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proBufferScales
                .concat(_this.props.bufferState.dewaxScale), function (s) { return s; })
                .map(function (v) {
                return {
                    text: v,
                    value: v
                };
            });
        };
        _this.sampleTypeOptions = function (b) {
            return b.sampleTypes.map(function (t) { return ({
                text: t.label,
                value: t.id
            }); });
        };
        _this.onSampleTypeChange = function (event, data) {
            var val = _this.props.catalog.sampleTypes.find(function (v) { return v.id === data.value; });
            if (val === undefined) {
                throw new RangeError("Could not find sample type " + data.value);
            }
            var update = { sampleType: val };
            _this.props.onBufferChange(update, _this.props.onUserSelection);
        };
        _this.onAmplificationScaleChange = function (event, data) {
            var val = data.value;
            var amplificationBufferScale = _this.props.catalog.proBufferScales.find(function (v) { return v === val; }) || val;
            _this.props.onBufferChange({
                amplificationBufferScale: amplificationBufferScale
            }, _this.props.onUserSelection);
        };
        _this.onBlockingScaleChange = function (event, data) {
            var val = data.value;
            var blockingSolutionScale = _this.props.catalog.proBufferScales.find(function (v) { return v === val; }) || val;
            _this.props.onBufferChange({
                blockingSolutionScale: blockingSolutionScale
            }, _this.props.onUserSelection);
        };
        _this.onEndogenousScaleChange = function (event, data) {
            var val = data.value;
            var endogenousEnzymeScale = _this.props.catalog.proBufferScales.find(function (v) { return v === val; }) || val;
            _this.props.onBufferChange({
                endogenousEnzymeScale: endogenousEnzymeScale
            }, _this.props.onUserSelection);
        };
        _this.onPreHybridizationScaleChange = function (event, data) {
            var val = data.value;
            var preHybridizationScale = _this.props.catalog.proBufferScales.find(function (v) { return v === val; }) || val;
            _this.props.onBufferChange({
                preHybridizationScale: preHybridizationScale
            }, _this.props.onUserSelection);
        };
        _this.onHrpQuencherScaleChange = function (event, data) {
            var val = data.value;
            var hrpQuencherScale = _this.props.catalog.proBufferScales.find(function (v) { return v === val; }) || val;
            _this.props.onBufferChange({
                hrpQuencherScale: hrpQuencherScale
            }, _this.props.onUserSelection);
        };
        _this.onBluingScaleChange = function (event, data) {
            var val = data.value;
            var bluingAgentScale = _this.props.catalog.proBufferScales.find(function (v) { return v === val; }) || val;
            _this.props.onBufferChange({
                bluingAgentScale: bluingAgentScale
            }, _this.props.onUserSelection);
        };
        _this.onDewaxScaleChange = function (event, data) {
            var val = data.value;
            var dewaxScale = _this.props.catalog.proBufferScales.find(function (v) { return v === val; }) || val;
            _this.props.onBufferChange({
                dewaxScale: dewaxScale
            }, _this.props.onUserSelection);
        };
        _this.onAntigenRetrievalScaleChange = function (event, data) {
            var val = data.value;
            var antigenRetrievalScale = _this.props.catalog.proBufferScales.find(function (v) { return v === val; }) || val;
            _this.props.onBufferChange({
                antigenRetrievalScale: antigenRetrievalScale
            }, _this.props.onUserSelection);
        };
        _this.onAddCustomScale = function (event, data) {
            if (typeof data.value !== 'number') {
                return;
            }
            var customScale = data.value;
            _this.props.onBufferChange({
                amplificationBufferScale: customScale,
                blockingSolutionScale: customScale,
                endogenousEnzymeScale: customScale,
                preHybridizationScale: customScale,
                hrpQuencherScale: customScale,
                bluingAgentScale: customScale,
                dewaxScale: customScale,
                antigenRetrievalScale: customScale,
            });
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onBufferChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, callback);
        };
        return _this;
    }
    BufferForm.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 3, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/sampleType', labelContent: React.createElement(React.Fragment, null,
                                "Sample type ",
                                React.createElement(Help, null, "Select the sample type for your experiments.")), labelFor: 'buffer-sample-type' },
                            React.createElement(Select, { name: 'buffer-sample-type', onChange: this.onSampleTypeChange, options: this.sampleTypeOptions(this.props.catalog), value: this.props.bufferState.sampleType.id }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/amplificationBufferScaleSlides', labelContent: React.createElement(React.Fragment, null, "Amplifier Buffer Scale"), labelFor: 'buffer-slides' },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'buffer-slides', onChange: this.onAmplificationScaleChange, options: this.amplificationScaleSlideOptions().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), allowAdditions: true, onAddItem: this.onAddCustomScale, search: true, value: this.props.bufferState.amplificationBufferScale }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/blockingSolutionScaleSlides', labelContent: React.createElement(React.Fragment, null, "Blocking Solution Scale"), labelFor: 'buffer-slides' },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'buffer-slides', onChange: this.onBlockingScaleChange, allowAdditions: true, onAddItem: this.onAddCustomScale, search: true, options: this.blockingSolutionScaleSlideOptions(), value: this.props.bufferState.blockingSolutionScale })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/endogenousEnzymeScaleSlides', labelContent: React.createElement(React.Fragment, null, "HCR\u2122 Endogenous Enzyme Block"), labelFor: 'buffer-slides' },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'buffer-slides', onChange: this.onEndogenousScaleChange, allowAdditions: true, onAddItem: this.onAddCustomScale, search: true, options: this.endogenousEnzymeScaleSlideOptions(), value: this.props.bufferState.endogenousEnzymeScale }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/preHybridizationScaleSlides', labelContent: React.createElement(React.Fragment, null, "HCR\u2122 Pre-Hybridization Buffer"), labelFor: 'buffer-slides' },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'buffer-slides', onChange: this.onPreHybridizationScaleChange, allowAdditions: true, onAddItem: this.onAddCustomScale, search: true, options: this.preHybridizationScaleSlideOptions(), value: this.props.bufferState.preHybridizationScale }))),
                    this.props.protocolType.id !== "ROCHE" &&
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/bluingAgentScaleSlides', labelContent: React.createElement(React.Fragment, null, "HCR\u2122 Bluing Reagent"), labelFor: 'buffer-slides' },
                                React.createElement(Select, { disabled: this.props.lockScales, name: 'buffer-slides', onChange: this.onBluingScaleChange, allowAdditions: true, onAddItem: this.onAddCustomScale, search: true, options: this.bluingAgentScaleSlideOptions(), value: this.props.bufferState.bluingAgentScale }))),
                    this.props.protocolType.id === "ROCHE" &&
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/antigenRetrievalScaleSlides', labelContent: React.createElement(React.Fragment, null, "HCR\u2122 Antigen Retrieval"), labelFor: 'buffer-slides' },
                                React.createElement(Select, { disabled: this.props.lockScales, name: 'buffer-slides', onChange: this.onAntigenRetrievalScaleChange, allowAdditions: true, onAddItem: this.onAddCustomScale, search: true, options: this.antigenRetrievalScaleSlideOptions(), value: this.props.bufferState.antigenRetrievalScale })))),
                React.createElement(Grid.Row, null,
                    this.props.protocolType.id !== "ROCHE" && React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/hrpQuencherScaleSlides', labelContent: React.createElement(React.Fragment, null, "HCR\u2122 HRP Quencher"), labelFor: 'buffer-slides' },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'buffer-slides', onChange: this.onHrpQuencherScaleChange, allowAdditions: true, onAddItem: this.onAddCustomScale, search: true, options: this.hrpQuencherScaleSlideOptions(), value: this.props.bufferState.hrpQuencherScale }))),
                    this.props.protocolType.id === "ROCHE" &&
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/buffersComponent/dewaxScaleSlides', labelContent: React.createElement(React.Fragment, null, "HCR\u2122 Dewax"), labelFor: 'buffer-slides' },
                                React.createElement(Select, { disabled: this.props.lockScales, name: 'buffer-slides', onChange: this.onDewaxScaleChange, allowAdditions: true, onAddItem: this.onAddCustomScale, search: true, options: this.dewaxScaleSlideOptions(), value: this.props.bufferState.dewaxScale }))),
                    React.createElement(Grid.Column, null)),
                this.props.buffComponent && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(React.Fragment, null,
                            this.props.buffComponent.amplificationBufferScale.label,
                            " / ",
                            this.props.buffComponent.amplificationBufferScale.detail),
                        React.createElement("br", null),
                        new MicroliterVolume(this.props.buffComponent.amplificationBufferScale.volumeScaleUl).valueWithUnit),
                    React.createElement(Grid.Column, null,
                        React.createElement(React.Fragment, null,
                            this.props.buffComponent.blockingSolutionScale.label,
                            " / ",
                            this.props.buffComponent.blockingSolutionScale.detail),
                        React.createElement("br", null),
                        new MicroliterVolume(this.props.buffComponent.blockingSolutionScale.volumeScaleUl).valueWithUnit),
                    React.createElement(Grid.Column, null,
                        React.createElement(React.Fragment, null,
                            this.props.buffComponent.endogenousEnzymeScale.label,
                            " / ",
                            this.props.buffComponent.endogenousEnzymeScale.detail),
                        React.createElement("br", null),
                        new MicroliterVolume(this.props.buffComponent.endogenousEnzymeScale.volumeScaleUl).valueWithUnit)),
                this.props.buffComponent && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(React.Fragment, null,
                            this.props.buffComponent.preHybridizationScale.label,
                            " / ",
                            this.props.buffComponent.preHybridizationScale.detail),
                        React.createElement("br", null),
                        new LiquidVolume(this.props.buffComponent.preHybridizationScale.volumeScaleMl).valueWithUnit),
                    !isRocheBuffersComponent(this.props.buffComponent) && React.createElement(Grid.Column, null,
                        React.createElement(React.Fragment, null, this.props.buffComponent.hrpQuencherScale.label),
                        React.createElement("br", null),
                        new LiquidVolume(this.props.buffComponent.hrpQuencherScale.volumeScaleMl).valueWithUnit),
                    !isRocheBuffersComponent(this.props.buffComponent) &&
                        React.createElement(Grid.Column, null,
                            React.createElement(React.Fragment, null, this.props.buffComponent.bluingAgentScale.label),
                            React.createElement("br", null),
                            new LiquidVolume(this.props.buffComponent.bluingAgentScale.volumeScale).valueWithUnit),
                    isRocheBuffersComponent(this.props.buffComponent) &&
                        React.createElement(Grid.Column, null,
                            React.createElement(React.Fragment, null, this.props.buffComponent.antigenRetrievalScale.label),
                            React.createElement("br", null),
                            new MicroliterVolume(this.props.buffComponent.antigenRetrievalScale.volumeScaleUl).valueWithUnit),
                    isRocheBuffersComponent(this.props.buffComponent) &&
                        React.createElement(Grid.Column, null,
                            React.createElement(React.Fragment, null, this.props.buffComponent.dewaxScale.label),
                            React.createElement("br", null),
                            new MicroliterVolume(this.props.buffComponent.dewaxScale.volumeScaleUl).valueWithUnit))),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    priceColumn(React.createElement(PriceDisplay, { loading: this.props.priceLoading, priceCents: this.props.priceCents }))),
                this.props.enableCustomPrice &&
                    React.createElement(CustomPriceRow, { customPrice: this.props.bufferState.customPrice, defaultEffectivePriceCents: this.props.priceCents, errors: this.props.errors, errorPathPrefix: '/buffersComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection })),
            React.createElement(ErrorDisplay, { errors: this.props.errors, errorPath: "/buffersComponent" }));
    };
    return BufferForm;
}(React.PureComponent));
export default BufferForm;
//# sourceMappingURL=BufferForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/BufferForm.js
// module id = 549
// module chunks = 0